import axios from 'axios';

import session from "@/utils/session";
import { logout } from './auth';

export const BASE_URL = '/api/v1/';


const instance = () => {
	const ax = axios.create({
		baseURL: BASE_URL,
		timeout: 60000
	});
	ax.interceptors.response.use((response) => {
		return response;
	}, async (error) => {
		if (!error.response ||
			(error.response.status === 401
				|| error.response.status === 504
				|| error.response.status === 500
				|| error.response.status === 0)) {
			await logout();
			if (error.response.status === 504
				|| error.response.status === 500
				|| error.response.status === 0) {
				window.location.replace("/error");
			}
			else {
				window.location.replace("/");
			}
		}

		return Promise.reject(error);
	});
	return ax;
};

export default instance;
